module.exports = __webpack_public_path__ + "static/media/menu.72c61f61.svg";